import { signout } from '../../../../../actions/signout';
import PeopleIcon from '../../../../../design-system/icons/PeopleIcon';
import ConfigurationIcon from '../../../../../design-system/icons/ConfigurationIcon';
import Routes from '../../../../../routes';
import { t } from '../../../../../utils/translate';
import { HeaderConfigItem } from '../../@types/HeaderConfig.d';
import MainMenuItem from '../../components/main-menu-item/MainMenuItem';
import UsernavItem from '../../components/usernav-item/UsernavItem';
import translations from './school-coach.translations';

const config: { main: HeaderConfigItem[], connected: HeaderConfigItem[] } = {
  main: [
    {
      component: MainMenuItem,
      type: 'link',
      key: 'students',
      to: Routes.schoolAssignmentsDashboard,
      label: t(translations.students),
      className: 'main-menu-item-link-white',
      icon: PeopleIcon,
    },
    {
      component: MainMenuItem,
      type: 'link',
      key: 'configuration',
      to: Routes.schoolAssignmentsConfiguration,
      label: t(translations.configuration),
      className: 'main-menu-item-link-white',
      icon: ConfigurationIcon,
    },
  ],
  connected: [
    {
      component: UsernavItem,
      type: 'link',
      key: 'settings',
      to: Routes.settings,
      label: t(translations.settings),
    },
    {
      component: UsernavItem,
      type: 'action',
      key: 'logout',
      onClick: (dispatch) => { dispatch(signout(Routes.home)); },
      label: t(translations.logout),
    },
  ],
};

export default config;
